<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select
      v-model="query.siteDeviceId"
      size="small"
      style="width:170px;"
      @change="onSiteDeviceChanged"
    >
      <el-option
        v-for="site in sites"
        :key="site.siteDevices[0].id"
        :value="site.siteDevices[0].id"
        :label="site.name"
      />
      <!-- <el-option-group
        v-for="site in sites"
        :key="site.id"
        :label="site.name"
      >
        <el-option
          v-for="siteDevice in site.siteDevices"
          :key="siteDevice.id"
          :value="siteDevice.id"
          :label="siteDevice.name"
        />
      </el-option-group> -->
    </el-select>

    <el-select
      v-model="query.factorId"
      size="small"
      style="width:150px;"
    >
      <el-option
        v-for="siteDeviceFactor in selectedSiteDeviceFactors"
        :key="siteDeviceFactor.factorId"
        :value="siteDeviceFactor.factorId"
        :label="siteDeviceFactor.name"
      />
    </el-select>

    <el-button
      :disabled="!query.factorId"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #filter>
    <section class="chart-option-wrapper">
      <el-input
        v-model="chartOpts.legendMinVal"
        type="number"
        size="small"
        style="width:180px;margin-left:.5em;"
        @change="onChartOptsChanged"
      >
        <template slot="prepend">图例最小值</template>
      </el-input>

      <el-input
        v-model="chartOpts.legendMaxVal"
        type="number"
        size="small"
        style="width:180px;margin-left:.5em;"
        @change="onChartOptsChanged"
      >
        <template slot="prepend">图例最大值</template>
      </el-input>

      <el-input
        v-model="chartOpts.minHeight"
        type="number"
        size="small"
        style="width:180px;margin-left:.5em;"
        @change="onChartOptsChanged"
      >
        <template slot="prepend">高度最小值</template>
      </el-input>

      <el-input
        v-model="chartOpts.maxHeight"
        type="number"
        size="small"
        style="width:180px;margin-left:.5em;"
        @change="onChartOptsChanged"
      >
        <template slot="prepend">高度最大值</template>
      </el-input>
    </section>
  </template>

  <template #body>
    <data-wrapper>
      <lidar-chart-wrapper
        @lidar-chart-ready="onLidarChartReady"
        @lidar-chart-destroy="onLidarChartDestroy"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseData from '../../BaseData'
import LidarChartWrapper from '../../../components/Data/ChartWrapper/LidarChartWrapper'
import {
  LIDAR_DATA_APPEND,
  LIDAR_DATA_INSERT,
  LIDAR_DATA_LIST_CHANGED
} from '../../../components/Data/ChartWrapper/EventKeys'
import {LIDAR_CHART_MOVED} from '../../../components/Data/Charts/LidarChart/EventKeys'
import DataTimeQuery from '../../../components/Data/Query/DataTimeQuery'
import DataWrapper from '../../../components/Data/DataWrapper'
import LayoutContent from '../../../components/Layout/Content'

export default {
  name: 'BaseLidar',
  extends: BaseData,
  components: {LayoutContent, DataWrapper, DataTimeQuery, LidarChartWrapper},
  data () {
    return {
      query: {
        siteDeviceId: null,
        factorId: null,
        isAudited: false
      },
      chartOpts: {
        legendMinVal: 0,
        legendMaxVal: 1.5,
        minHeight: 200,
        maxHeight: 3495
      }
    }
  },
  computed: {
    siteDeviceCategory: () => process.env.QI_RONG_JIAO_LIDAR_DEVICE_CATEGORY,
    selectedFactor () {
      let {factorId} = this.query
      return this.selectedSiteDeviceFactors.find(siteDeviceFactor => siteDeviceFactor.factorId === factorId)
    }
  },
  methods: {
    onLidarChartReady (lidarEB) {
      this.lidarEB = lidarEB
      this.lidarEB.$on(LIDAR_CHART_MOVED, this[LIDAR_CHART_MOVED])
    },
    onLidarChartDestroy () {
      this.lidarEB.$off(LIDAR_CHART_MOVED, this[LIDAR_CHART_MOVED])
      this.lidarEB = null
    },
    [LIDAR_CHART_MOVED] (param) {
      let {dataTimes} = this
      let {beginXAxisValue, endXAxisValue, directX} = param
      let {currentQuery} = this

      if (directX > 0) {
        let beginDate = new Date(beginXAxisValue)
        beginDate.setHours(0, 0, 0)

        if (beginDate.getTime() === dataTimes[0].getTime()) {
          let beginTime = new Date(dataTimes[0])
          beginTime.setDate(beginTime.getDate() - 1)
          dataTimes.unshift(beginTime)
          currentQuery.beginTime = beginTime.format('YYYY/MM/DD 00:00:00')
          this.getLidarDataCache(beginTime, LIDAR_DATA_INSERT, 0)
        }
      } else if (directX < 0) {
        let endDate = new Date(endXAxisValue)

        endDate.setHours(0, 0, 0)
        let ts = endDate.getTime()

        if (ts === dataTimes[dataTimes.length - 1].getTime()) {
          let now = new Date()
          now.setHours(0, 0, 0, 0)

          if (ts < now.getTime()) {
            endDate.setDate(endDate.getDate() + 1)
            dataTimes.push(endDate)
            currentQuery.endTime = endDate.format('YYYY/MM/DD 23:59:59')
            this.getLidarDataCache(endDate, LIDAR_DATA_APPEND, 1)
          }
        }
      }
    },
    onSitesChanged () {
      let {query} = this

      if (!query.siteDeviceId) {
        query.siteDeviceId = this.sites[0].siteDevices[0].id
      }

      this.baseParamsInitialized()
    },
    baseParamsInitialized () {
      let {query} = this

      if (!query.factorId) {
        let {selectedSiteDeviceFactors} = this

        if (selectedSiteDeviceFactors.length === 0) {
          return
        }

        query.factorId = selectedSiteDeviceFactors[0].factorId
        this.setChartOpts()
      }

      this.getLidarData()
    },
    getLidarData () {
      let {query} = this
      let beginTime = new Date(query.beginTime)
      let endTime = new Date(query.endTime)
      let endTS = endTime.getTime()
      let dataTimes = this.dataTimes = []

      while (beginTime.getTime() <= endTS) {
        dataTimes.push(new Date(beginTime))
        beginTime.setDate(beginTime.getDate() + 1)
      }

      this.changeLoadStatus(true)
      this.$api.Data.getLidarData(query).then(dataList => {
        this.dataList = Object.freeze(this.getFormatDataList(dataList))
        this.setCurrentQuery()
        this.setChartOpts()
        this.renderChart()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getFormatDataList (dataList) {
      return dataList.map(data => ({
        dataTime: data.dataTime,
        value: data.dasValue.split('|').map(value => value === '' ? null : Number(value))
      }))
    },
    getLidarDataCache (dataTime, command, index) {
      let {currentQuery} = this
      let endTime = dataTime.format('YYYY/MM/DD 23:59:59')
      let query = {
        beginTime: dataTime.format('YYYY/MM/DD 00:00:00'),
        endTime,
        siteDeviceId: currentQuery.siteDeviceId,
        factorId: currentQuery.factorId,
        isAudited: false
      }

      this.$api.Data.getLidarData(query).then(dataList => {
        dataList = this.getFormatDataList(dataList)

        let tmpDataList = new Array(2)
        tmpDataList[index] = dataList
        tmpDataList[index ^ 1] = this.dataList || []

        this.dataList = Object.freeze(tmpDataList.flat())

        this.lidarEB.$emit(command, {
          beginTime: dataTime,
          endTime: new Date(endTime),
          values: dataList
        })
      }).catch(console.error).finally(() => {
        dataTime = null
        endTime = null
        command = null
      })
    },
    renderChart () {
      let {dataList} = this

      if (!Array.isArray(dataList)) {
        return
      }

      let {currentQuery} = this

      if (!currentQuery) {
        return
      }

      let {chartOpts} = this
      let {
        beginTime,
        endTime,
        siteDevice,
        siteDeviceFactor
      } = currentQuery

      beginTime = new Date(beginTime)
      endTime = new Date(endTime)

      for (let key in chartOpts) {
        chartOpts[key] = Number(chartOpts[key])
      }

      this.lidarEB.$emit(LIDAR_DATA_LIST_CHANGED, {
        id: siteDeviceFactor.id,
        name: siteDeviceFactor.name,
        heights: siteDevice.detectionHeights,
        values: dataList,
        dataFrequency: siteDevice.dataFrequency,
        beginTime,
        endTime,
        colors: [[0, 0, 255], [0, 255, 255], [0, 255, 0], [255, 255, 0], [255, 0, 0]],
        ...chartOpts
      })
    },
    onSiteDeviceChanged () {
      let {selectedSiteDeviceFactors} = this
      this.query.factorId = selectedSiteDeviceFactors.length > 0 ? selectedSiteDeviceFactors[0].factorId : null
      this.setChartOpts()
    },
    setCurrentQuery () {
      this.currentQuery = {
        ...this.query,
        siteDevice: this.selectedSiteDevice,
        siteDeviceFactor: this.selectedFactor
      }
    },
    setChartOpts () {
      let {selectedFactor} = this
      let {chartOpts} = this

      if (selectedFactor) {
        chartOpts.legendMinVal = selectedFactor.limitLow
        chartOpts.legendMaxVal = selectedFactor.limitHigh
      }
    },
    onSearchBtnClick () {
      this.getLidarData()
    },
    onChartOptsChanged () {
      this.renderChart()
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper {
  user-select: none;
}

.chart-option-wrapper {
  text-align: center;

  .el-input {
    /deep/ .el-input-group__prepend {
      padding: {
        right: 7px;
        left: 7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/BaseLidar.vue